// extracted by mini-css-extract-plugin
export default {"heading":"UserLogin_heading__DTb7G","subheading":"UserLogin_subheading__8tuDY","cursor":"UserLogin_cursor__Hn3nd","loginButton":"UserLogin_loginButton__GVPKQ"};